export default {
  namespaced: true,
  state: {
    pdfToShow: null,
    lastKnownVersion: null,
    newVersionAvailable: false,
  },
  mutations: {
    setPDFToShow(state, { data }) {
      state.pdfToShow = data;
      state.pdfCurrentPage = 1;
    },
    setCurrentPage(state, { pageNumber }) {
      state.pdfCurrentPage = pageNumber;
    },
    setLastKnownVersion(state, { version }) {
      if (state.lastKnownVersion === null) {
        state.lastKnownVersion = version;
      } else if (state.lastKnownVersion !== version) {
        state.newVersionAvailable = true;
        state.lastKnownVersion = version;
      }
    }
  },
  actions: {
    async showPDF({ commit }, { data }) {
      commit("setPDFToShow", { data });
    },

    async changePage({ commit }, { pageNumber }) {
      commit("setCurrentPage", { pageNumber });
    },

    setLastKnownVersion({ commit }, version) {
      commit("setLastKnownVersion", { version });
    }
  }
};
